module.exports = __webpack_public_path__ + "img/thumbnail_Blackbuck_m_normal.713339e6.png";